import { useEffect } from "react";
import { Link } from "react-router-dom";
import PublicNav from "@/components/landing/PublicNav";
import PublicFooter from "@/components/landing/PublicFooter";
import { applyMeta, metaFor } from "@/lib/seo";

const LINKS = [
  ["Fortune skill game cabinet", "/fortune", "A 43-inch skill game machine, $3,500 all in with a 6-game pack."],
  ["AOG Sweeps game kiosk", "/aog-coin", "A free sweepstakes game kiosk for the counter in eligible states, 21+."],
  ["Coverage by state", "/states", "Verified venue owners for route operators in all 50 states and DC."],
  ["Pricing", "/pricing", "Scout, Full Operator and the Placement Engine."],
  ["Blog", "/blog", "Plain guides on skill games, pre-reveal games and sweepstakes kiosks."],
];

// Real 404 page: noindex, no redirect, links back into the site. Prerendered to build/404.html so static hosts can serve it with a 404 status.
export default function NotFound() {
  useEffect(() => { applyMeta(metaFor("/404.html")); }, []);
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="not-found-page">
      <PublicNav />
      <main className="max-w-4xl mx-auto px-4 pt-16 sm:pt-24 pb-20">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neon-magenta">Error 404</div>
        <h1 className="mt-3 font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">That page doesn't exist.</h1>
        <p className="mt-5 max-w-xl text-base text-white/65">The link may be old or mistyped. Here is where most people are heading:</p>
        <ul className="mt-8 grid sm:grid-cols-2 gap-3" data-testid="not-found-links">
          {LINKS.map(([label, href, sub]) => (
            <li key={href}>
              <Link to={href} data-testid={`not-found-link-${href.replace(/\W+/g, "") || "home"}`} className="block border border-border/70 bg-black/30 p-4 hover:border-neon-yellow/70 transition-colors">
                <div className="font-heading font-bold">{label}</div>
                <div className="mt-1 text-sm text-white/60">{sub}</div>
              </Link>
            </li>
          ))}
        </ul>
        <Link to="/" data-testid="not-found-home" className="mt-8 inline-flex items-center h-11 px-5 bg-neon-yellow text-black hover:bg-white transition-colors font-heading font-bold text-sm uppercase tracking-wide">Back to the homepage</Link>
      </main>
      <PublicFooter />
    </div>
  );
}
